export default "__VITE_ASSET__BzM7sGDt__"